import React from 'react';
import Chart from 'react-apexcharts'
import { SERVER_IP, PORT, ud, auth_response_flow, jwt } from '../../Server'
import axios from 'axios';
class DashboardChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

      // User

      series1: [{
        name: 'Users',
        data: []
      }],
      options1: {
        annotations: {
          points: [{
            x: 'gsk',
            seriesIndex: 0,
            label: {
              borderColor: '#775DD0',
              offsetY: 0,
              style: {
                color: '#fff',
                background: '#775DD0',
              },
              text: 'gsk are good',
            }
          }]
        },
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2
        },

        grid: {
          row: {
            colors: ['#fff', '#f2f2f2']
          }
        },
        xaxis: {
          labels: {
            rotate: -45
          },
          categories: [],
          tickPlacement: 'on'
        },
        yaxis: {
          title: {
            text: 'Total Users',
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100]
          },
        }
      },
      series2: [{
        name: 'Users',
        data: []
      }],
      options2: {
        annotations: {
          points: [{
            x: 'gsk',
            seriesIndex: 0,
            label: {
              borderColor: '#775DD0',
              offsetY: 0,
              style: {
                color: '#fff',
                background: '#775DD0',
              },
              text: 'gsk are good',
            }
          }]
        },
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2
        },

        grid: {
          row: {
            colors: ['#fff', '#f2f2f2']
          }
        },
        xaxis: {
          labels: {
            rotate: -45
          },
          categories: [],
          tickPlacement: 'on'
        },
        yaxis: {
          title: {
            text: 'Total Workflow',
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100]
          },
        }
      },


      // storage

      seriesStorage: [{
        name: 'Storage Used',
        data: [44, 55, 41, 67, 22, 43, 21, 49]
      }, {
        name: 'Storage Left',
        data: [13, 23, 20, 8, 13, 27, 33, 12]
      }],
      optionsStorage: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          stackType: '100%'
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        xaxis: {
          categories: ['J&J', 'Lupin', 'HCL', 'NPCL', 'Gail', 'Mahindra',
            'Honeywell', 'Godrej'
          ],
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'right',
          offsetX: 0,
          offsetY: 50
        },
      },


      //licence
      serieslicence: [
        {
          name: "New Users",
          data: [28, 29, 33, 36, 32, 32, 33, 55, 48, 26, 75, 20]
        },
        {
          name: "Renewed Users",
          data: [12, 11, 14, 18, 17, 13, 13, 29, 33, 36, 32, 15]
        }
      ],
      optionslicence: {
        chart: {
          height: 350,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: false
          }
        },
        colors: ['#28a745', '#008ffb'],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: 'Average New & Renewed Licence',
          align: 'left'
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        markers: {
          size: 1
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          title: {
            text: 'Month'
          }
        },
        yaxis: {
          title: {
            text: 'Licence Issued'
          },
          min: 5,
          max: 100
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      },
      TotalUsers: 0,
      TotalWorkflow: 0

    }
  }
  componentDidMount() {
    this.getTotalUserWorkflow();
  }
  getTotalUserWorkflow = () => {
    var data = {
      simulanis_id: ud.id
    }
    let _this = this;
    let headers = {
      'user_id': (ud.id).toString(),
      'session_id': (ud.session_id).toString(),
      'user_type': (ud.usertype).toString(),
      'main_id': (ud.main_id).toString(),
      'jwt_token': (jwt),
      'c_id': (ud.c_id).toString()
    }
    axios.post(`${SERVER_IP}/dashboardSimulanis`, data, { withCredentials: true, headers: headers })
      .then(function (response) {

        if (response.data.error == false) {

          let corporate_Name_user = []
          let corporate_value_user = []
          let corporate_Name_workflow = []
          let corporate_value_workflow = []
          let TotalUsers = 0
          let TotalWorkflow = 0
          response.data.total_users.map(list => {
            corporate_Name_user.push(list.cooperate_name)
            corporate_value_user.push(list.total_users)
            TotalUsers += list.total_users
          })
          response.data.total_workflows.map(list => {
            corporate_Name_workflow.push(list.cooperate_name)
            corporate_value_workflow.push(list.total_workflows)
            TotalWorkflow += list.total_workflows
          })

          _this.setState({
            series1: [{
              name: 'Users',
              data: corporate_value_user
            }],
            options1: {
              annotations: {
                points: [{
                  x: 'gsk',
                  seriesIndex: 0,
                  label: {
                    borderColor: '#775DD0',
                    offsetY: 0,
                    style: {
                      color: '#fff',
                      background: '#775DD0',
                    },
                    text: 'gsk are good',
                  }
                }]
              },
              chart: {
                height: 350,
                type: 'bar',
              },
              plotOptions: {
                bar: {
                  columnWidth: '50%',
                  endingShape: 'rounded'
                }
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                width: 2
              },

              grid: {
                row: {
                  colors: ['#fff', '#f2f2f2']
                }
              },
              xaxis: {
                labels: {
                  rotate: -45
                },
                categories: corporate_Name_user,
                tickPlacement: 'on'
              },
              yaxis: {
                title: {
                  text: 'Total Users',
                },
              },
              fill: {
                type: 'gradient',
                gradient: {
                  shade: 'light',
                  type: "horizontal",
                  shadeIntensity: 0.25,
                  gradientToColors: undefined,
                  inverseColors: true,
                  opacityFrom: 0.85,
                  opacityTo: 0.85,
                  stops: [50, 0, 100]
                },
              }
            },
            series2: [{
              name: 'Workflow',
              data: corporate_value_workflow
            }],
            options2: {
              annotations: {
                points: [{
                  x: 'gsk',
                  seriesIndex: 0,
                  label: {
                    borderColor: '#775DD0',
                    offsetY: 0,
                    style: {
                      color: '#fff',
                      background: '#775DD0',
                    },
                    text: 'gsk are good',
                  }
                }]
              },
              chart: {
                height: 350,
                type: 'bar',
              },
              plotOptions: {
                bar: {
                  columnWidth: '50%',
                  endingShape: 'rounded'
                }
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                width: 2
              },

              grid: {
                row: {
                  colors: ['#fff', '#f2f2f2']
                }
              },
              xaxis: {
                labels: {
                  rotate: -45
                },
                categories: corporate_Name_workflow,
                tickPlacement: 'on'
              },
              yaxis: {
                title: {
                  text: 'Total Workflow',
                },
              },
              fill: {
                type: 'gradient',
                gradient: {
                  shade: 'light',
                  type: "horizontal",
                  shadeIntensity: 0.25,
                  gradientToColors: undefined,
                  inverseColors: true,
                  opacityFrom: 0.85,
                  opacityTo: 0.85,
                  stops: [50, 0, 100]
                },
              }
            },
            TotalUsers: TotalUsers,
            TotalWorkflow: TotalWorkflow
          })
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.getTotalUserWorkflow();
            }
          })
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  render() {
    return (
      <div>
        <div className="row mt-4">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="card">
              <div className="card-header">
                <h4>Organization Overview </h4>
              </div>
              <div className="card-body">
                <div className="xp-chart-label">
                  <ul className="list-inline">
                    <li className="list-inline-item">
                      <p className="text-black">Total Users</p>
                      <h4 className="text-dark mb-3"><i className="mdi mdi-account-multiple mr-2"></i> {this.state.TotalUsers}</h4>
                    </li>

                    <li className="list-inline-item">
                      <p className="text-black">Total Workflows</p>
                      <h4 className="text-dark mb-3"><i className="mdi mdi-lan mr-2"></i> {this.state.TotalWorkflow}</h4>
                    </li>

                    <li className="list-inline-item">
                      <p className="text-black"> Total Licence</p>
                      <h4 className="text-dark mb-3"><i className="mdi mdi-file-account mr-2"></i> N/A</h4>
                    </li>

                    <li className="list-inline-item">
                      <p className="text-black">Total Used Storage</p>
                      <h4 className="text-dark mb-3"><i className="mdi mdi-database mr-2"></i> N/A</h4>
                    </li>

                    <li className="list-inline-item">
                      <p className="text-black">Total Queries</p>
                      <h4 className="text-dark mb-3"><i className="mdi mdi-message mr-2"></i> N/A</h4>
                    </li>
                  </ul>
                </div>

                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4">
                    <div className="card">
                      <div className="card-body">
                        <h4>Users</h4>
                        <Chart options={this.state.options1} series={this.state.series1} type="bar" height={350} />
                      </div>
                    </div>

                  </div>


                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4">
                    <div className="card">
                      <div className="card-body">
                        <h4>Workflow</h4>
                        <Chart options={this.state.options2} series={this.state.series2} type="bar" height={350} />
                      </div>
                    </div>

                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4">
                    <div className="card">
                      <div className="card-body">
                        <h4>Storage <marquee scrollamount="4" behavior="scroll"> <small>(This chart will be live on next phase.)</small> </marquee></h4>
                        <Chart options={this.state.optionsStorage} series={this.state.seriesStorage} type="bar" height={350} />
                      </div>
                    </div>

                  </div>


                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4">
                    <div className="card">
                      <div className="card-body">
                        <h4>Licence <marquee scrollamount="4" behavior="scroll"> <small>(This chart will be live on next phase.)</small> </marquee></h4>
                        <Chart options={this.state.optionslicence} series={this.state.serieslicence} type="line" height={350} />
                      </div>
                    </div>

                  </div>

                </div>

              </div>
            </div>
          </div>


        </div>

      </div>



    )
  }
}

export default DashboardChart